module.exports = __webpack_public_path__ + "assets/img/logob.63419321.png";